export default {
  name: "video-player-youtube",
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    isKeepInViewportMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    videoId() {
      if (!this.videoUrl) return null;

      const regex =
        /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|embed|shorts|watch)(?:\.php)?(?:\?|#\/)?(?:.*?v=|v\/|\/))|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = this.videoUrl.match(regex);
      return match ? match[1] : null;
    },
  },
  methods: {
    initYouTubePlayer() {
      if (!window.YT) {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = this.createYouTubePlayer;
      } else {
        this.createYouTubePlayer();
      }
    },

    createYouTubePlayer() {
      if (!this.$refs.videoContainer) {
        return console.error("Youtube video container not found");
      }
      if (!this.videoId) return console.error("Youtube video id not defined");

      this.videoContainer = new window.YT.Player(this.$refs.videoContainer, {
        videoId: this.videoId,
        playerVars: {
          playsinline: 1,
          enablejsapi: 1,
          rel: 0,
        },
      });
    },
  },
  mounted() {
    this.initYouTubePlayer();
  },
};
